module.exports = __webpack_public_path__ + "media/toolkits/line-middle-46a7cb83.png";